export default {
  init() {

    //APPEND CUSTOM CHECKBOX ELEMENT - GEESHOP CUSTOM PLUGIN - CHECKOUT PAGE

    const geesSoftCustomCheckbox = document.querySelector('#gees_custom_checkout_field');

    if (geesSoftCustomCheckbox) {
      const geesSoftCustomCheckboxContainer = geesSoftCustomCheckbox.querySelector('.woocommerce-input-wrapper');
      const geesSoftCustomCheckboxLabel = geesSoftCustomCheckboxContainer.querySelector('label.checkbox');

      const customCheckboxElement = document.createElement('span');
      customCheckboxElement.classList.add('checkmark');
      geesSoftCustomCheckboxLabel.append(customCheckboxElement);
    }

  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCheckout.js